/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { OriginType, SanctioningBodyEnum, TelemetryData } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class TelemetryService extends RSocketStreamBaseService<TelemetryData[], TelemetryData> {
  protected getStreamHistoryRequest(): Promise<TelemetryData[] | undefined> {
    return Promise.resolve([]);
  }

  private telemetries = new Map<string, TelemetryData>();

  protected onDataCallback: (data: TelemetryData) => void = (data) => {
    this.telemetries.set(data.vehicleNumber, data);
    this.localCache = Array.from(this.telemetries.values());
  };

  async start() {
    this.delay = 200;
    super.start();
  }
}

export const telemetryService: Map<SanctioningBodyEnum, Map<OriginType, TelemetryService>> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new Map(
        (Object.values(OriginType) as OriginType[])
          .filter((x) => typeof x === 'number')
          .map((source: OriginType) => [
            source,
            new TelemetryService({
              route: 'stream.vehicleLocation',
              connectionType: StreamRequestType.MotorsportsStreamApi,
              originType: source,
              sanctioningBody: sanctioningBody,
            }),
          ])
      ),
    ])
);
